import React from 'react';

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius: { sm: 6, md: 8, lg: 12 },
  colors: {
    primary: "#0F172A",
    secondary: "#334155",
    muted: "#64748B",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#3B82F6"
  }
};

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, pageSize }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };
  
  const startIndex = (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, totalItems);
  
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: UI.spacing.lg,
      flexWrap: 'wrap',
      gap: UI.spacing.md
    }}>
      <div style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 12,
        color: UI.colors.muted
      }}>
        Showing {startIndex}–{endIndex} of {totalItems}
      </div>
      
      <div style={{ display: 'flex', gap: UI.spacing.sm }}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{
            padding: `${UI.spacing.sm}px ${UI.spacing.md}px`,
            background: UI.colors.white,
            border: `1px solid ${UI.colors.border}`,
            borderRadius: UI.radius.sm,
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            opacity: currentPage === 1 ? 0.5 : 1,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 12
          }}
        >
          ← Prev
        </button>
        
        {getPageNumbers().map((page, idx) => (
          <button
            key={idx}
            onClick={() => typeof page === 'number' && onPageChange(page)}
            style={{
              padding: `${UI.spacing.sm}px ${UI.spacing.md}px`,
              background: currentPage === page ? UI.colors.primary : UI.colors.white,
              color: currentPage === page ? UI.colors.white : UI.colors.primary,
              border: `1px solid ${UI.colors.border}`,
              borderRadius: UI.radius.sm,
              cursor: typeof page === 'number' ? 'pointer' : 'default',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 12,
              fontWeight: currentPage === page ? 600 : 400
            }}
          >
            {page}
          </button>
        ))}
        
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            padding: `${UI.spacing.sm}px ${UI.spacing.md}px`,
            background: UI.colors.white,
            border: `1px solid ${UI.colors.border}`,
            borderRadius: UI.radius.sm,
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            opacity: currentPage === totalPages ? 0.5 : 1,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: 12
          }}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default Pagination;